import React from 'react';
import {Row, Col, Table, Button} from 'antd'
import { useTranslation } from 'react-i18next';

const ParticipacionSoc = ({sociedades, actual, record, forceExpand}) => {
    const { t } = useTranslation();
    const socRecColumns = () => {
        const columns = [
            {
            title: t("messages.aml.company"),
            dataIndex: 'razonSoc'
            },
            {
            title: t("messages.aml.identificationNumber"),
            dataIndex: 'nroId'
            },
            {
            title: t("messages.aml.country"),
            dataIndex: 'pais'
            },
            {
            title: t("messages.aml.participationPercentage"),
            dataIndex: 'porcParti'
            },
            {
            title: t("messages.aml.propertyType"),
            dataIndex: 'tipoPropiedad'
            },
        ]
        if (record.type === 'Person'){
            columns.push(
            {
                title: t("messages.aml.position"),
                dataIndex: 'cargo'
            },
            )
        }

        columns.push(
            {
            title: t("messages.aml.indirectPropertyCompanyName"),
            dataIndex: 'nombrePropIndirect'
            },
            {
            title: t("messages.aml.indirectPropertyCompanyId"),
            dataIndex: 'nroIdPropIndirect'
            }
        )

        return columns
        }
    return (
        <div>
            <Row gutter={[32, 12]}>
                <Col span={22}>
                    {t("messages.aml.participatesInSocieties")}
                </Col>
                <Col span={2}>
                    <Button type="primary" className="radioDecision">
                        {sociedades && sociedades.hasSociedades ? t("messages.aml.yes") : t("messages.aml.no")}
                    </Button>
                </Col>
                </Row>
                {sociedades && sociedades.hasSociedades &&
                <Row className="field-section-row">
                    <Col span={24}>
                    <Table
                        className={actual && sociedades.socRecords !== actual.socRecords && "difference"}
                        columns={socRecColumns()}
                        dataSource={sociedades && sociedades.socRecords}
                        pagination={!forceExpand && sociedades?.socRecords?.length > 10 }
                    />
                    </Col>
                </Row>
                }
        </div>
    );
};

export default ParticipacionSoc;